var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoxClosedBlueRotated = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none",
    viewBox: "0 0 35 35",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B3DDFF",
    d: "M.0051 8.0508v17.6119l17.3288 8.9807V17.1389z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCE8FF",
    d: "M17.334 0 0 8.0569l17.325 9.1441 17.3417-8.5008z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DD3FF",
    d: "M34.6642 8.7031 17.334 17.1922v17.4741l17.3302-8.905V8.7031"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCE8FF",
    d: "M23.969 13.9506v8.7835l4.7709-2.3736v-8.7726z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5F3FF",
    d: "m6.3809 5.0823 17.5882 8.8704 4.7709-2.3736-17.4674-8.7705z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoxClosedBlueRotated);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/box-closed-blue-rotated.d05011af452d2c7ce8acf2811a2fa6b3.svg";